import React from "react";
import { Popconfirm, Button } from 'antd';

type ConfirmButtonProps = {
    disabled?: boolean,
    onConfirm: () => void,
    confirmTitle: string,
    children?: React.ReactNode,
    buttonType?: "link" | "ghost" | "primary" | "default" | "dashed" | undefined
    okText?: string,
    cancelText?: string,
    danger?: boolean
};

const ConfirmButton: React.FunctionComponent<ConfirmButtonProps> = ({ children, onConfirm, disabled, confirmTitle, buttonType, okText, cancelText, danger })  => {
  return (
    <Popconfirm
    title={confirmTitle}
    onConfirm={onConfirm}
    okText="Yes"
    cancelText="No"
  >
      <Button type={buttonType} danger={danger} disabled={disabled} htmlType="submit">{children}</Button>
  </Popconfirm>
  );
};

ConfirmButton.defaultProps = {
    okText: "Yes",
    cancelText: "No"
}

export default ConfirmButton; 